// extracted by mini-css-extract-plugin
module.exports = {"SectionInfo":"SectionInfo_SectionInfo__2vOC5","main":"SectionInfo_main__w0AXu"};